import NeighborhoodPage from "@/components/NeighborhoodPage";

const Lagoa = () => (
  <NeighborhoodPage
    name="Lagoa"
    slug="lagoa"
    description="Vista para a Lagoa Rodrigo de Freitas, um dos endereços mais desejados do Rio. Alto padrão, natureza e localização privilegiada entre Ipanema, Leblon e Jardim Botânico."
  />
);

export default Lagoa;
